import { differenceInDays } from 'date-fns';
import { formatDateNumeric, fromDateString } from '@/common/utils/dateFormats';

export const DEADLINE_PILL_HEIGHT = 16;
const DEADLINE_MARKER_COLOR = '#bd8a82';

export const TimelineDeadlineMarker = ({
  deadlineDate,
  from,
  to,
  dayWidth,
  laneHeight,
  lineHeight,
}: {
  deadlineDate: string;
  from: string;
  to: string;
  dayWidth: number;
  laneHeight: number;
  lineHeight: number;
}) => {
  const fromDate = fromDateString(from);
  const toDate = fromDateString(to);
  const deadline = fromDateString(deadlineDate);
  if (!fromDate || !toDate || !deadline) return null;

  if (deadline < fromDate || deadline > toDate) return null;

  const daysFromStart = differenceInDays(deadline, fromDate);

  return (
    <div
      aria-hidden="true"
      className="absolute top-0 -translate-x-1/2 pointer-events-none z-30"
      style={{ left: daysFromStart * dayWidth, height: laneHeight }}
    >
      <div
        className="absolute top-0 left-1/2 w-0.5 -translate-x-1/2"
        style={{ height: lineHeight, backgroundColor: DEADLINE_MARKER_COLOR }}
      />
      <div
        className="absolute top-0 left-1/2 flex -translate-x-1/2 items-center rounded-full border bg-bg-surface-base px-1.5 text-[10px] font-bold leading-none whitespace-nowrap"
        style={{
          height: DEADLINE_PILL_HEIGHT,
          borderColor: DEADLINE_MARKER_COLOR,
          color: DEADLINE_MARKER_COLOR,
        }}
      >
        {formatDateNumeric(deadlineDate)}
      </div>
    </div>
  );
};
